import Vue from 'vue'

export default new Vue()

export const ONLINE: string = 'ONLINE'
export const OFFLINE: string = 'OFFLINE'
export const SYNC: string = 'SYNC'
